import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'
import users from './users'
import places from './places'
import accommodations from './accommodations'
import stops from './stops'
import itineraries from './itineraries'
import trips from './trips'
import reviews from './reviews'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    {
      path: '/',
      name: 'home',
      redirect: { name: 'users' },
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home'),
      children: [
        users,
        places,
        accommodations,
        stops,
        itineraries,
        trips,
        reviews
        // {
        //   path: 'users',
        //   name: 'users',
        //   component: () =>
        //     import(/* webpackChunkName: "users" */ '@/views/Home/Users')
        // },
        // {
        //   path: 'users/:id',
        //   name: 'user.details',
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "users" */ '@/views/Home/Users/UserDetails'
        //     )
        // },
        // {
        //   path: 'places',
        //   name: 'places',
        //   component: () =>
        //     import(/* webpackChunkName: "places" */ '@/views/Home/Places')
        // },
        // {
        //   path: 'places/create',
        //   name: 'places.create',
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "places" */ '@/views/Home/Places/CreatePlace'
        //     )
        // },
        // {
        //   path: 'places/update/:id',
        //   name: 'places.update',
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "places" */ '@/views/Home/Places/UpdatePlace'
        //     )
        // }
        // {
        //   path: 'inbox',
        //   name: 'inbox',
        //   component: () =>
        //     import(/* webpackChunkName: "inbox" */ '@/views/Home/Inbox')
        // },
        // {
        //   path: 'content',
        //   name: 'content',
        //   component: () =>
        //     import(/* webpackChunkName: "content" */ '@/views/Home/Content')
        // },
        // {
        //   path: 'notification',
        //   name: 'notification',
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "push-notification" */ '@/views/Home/Notification'
        //     )
        // },
        // {
        //   path: 'settings',
        //   name: 'settings',
        //   component: () =>
        //     import(/* webpackChunkName: "settings" */ '@/views/Home/Settings')
        // },
        // {
        //   path: 'reports',
        //   name: 'reports',
        //   component: () =>
        //     import(/* webpackChunkName: "reports" */ '@/views/Home/Reports')
        // }
      ]
    }
  ]
})
